/* eslint-disable no-plusplus */

import checkAnalyticsFunctionMap from '../utils/checkAnalyticsFunctionMap';

async function getVariable(variable: string): Promise<string> {
  // @ts-ignore
  if (typeof gtag !== 'undefined') {
    let timeoutFn: NodeJS.Timeout;

    const main = new Promise<string>((resolve) => {
      // @ts-ignore
      gtag('get', process.env.NEXT_PUBLIC_GA4, variable, resolve);
    });

    const maxTimeout = process.env.NEXT_PUBLIC_GA4_TIMEOUT
      ? parseInt(process.env.NEXT_PUBLIC_GA4_TIMEOUT, 2)
      : 3000;

    const timeout = new Promise<string>((res) => {
      timeoutFn = setTimeout(() => res(''), maxTimeout);
    });

    return Promise.race([main, timeout]).finally(() => clearTimeout(timeoutFn));
  }

  return '';
}

const assignEvent = (ga4Key: string | undefined, eventName: string, event?: any) => {
  /**
   * `gtag` function is set to the window by the Google Analytics scripts
   */
  // @ts-ignore
  if (typeof gtag !== 'undefined' && ga4Key !== undefined) {
    // @ts-ignore
    gtag('get', ga4Key, 'session_id', (value) => {
      const ga4Event = { ...event, non_interaction: true, ga_session_id: value };
      // @ts-ignore
      gtag('event', eventName, ga4Event);
    });
  }
};

const ga4 = {
  getVariable,
  assignEvent,
};

export default checkAnalyticsFunctionMap(ga4) as typeof ga4;
